import React from 'react';
import {UseFormReturn} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {PresentationSettingsFormType} from '../../../../../incase-domain/validators/presentation/presentationSchema';
import PresentationRequestParameterForm from '../../../../components/PresentationRequestParameterForm';

interface AccessLinksSettingsProps {
    useForm: UseFormReturn<PresentationSettingsFormType>;
}

function AccessLinksSettings({useForm}: AccessLinksSettingsProps): JSX.Element {
    const {t} = useTranslation();

    const {watch} = useForm;
    const presentation = watch('presentation');

    if (!presentation._id) return <div />;

    return (
        <>
            <div className="c-verticalNavigation__header">
                <div className="c-verticalNavigation__header_title">{t('presEditPage.settings.requestParameters.title')}</div>
            </div>
            <PresentationRequestParameterForm useForm={useForm} />
        </>
    );
}

export default AccessLinksSettings;
